import { useQueries } from '@tanstack/react-query'

import {
  getListConversationsApiV1ConversationsGetQueryKey,
  listConversationsApiV1ConversationsGet,
} from '#/shared/api/generated/communication/theCargoCommunication'

/**
 * Total unread inbound items across the given counterparty numbers — drives the
 * unread badge on the shipment sidebar chat tab. Runs one lightweight list query
 * per number (`q` search) and sums the unread_count of the conversation whose
 * `to_number` matches, optionally scoped to the owning agent.
 */
export function useChatUnreadCount(
  phones: ReadonlyArray<string>,
  userId?: string,
): number {
  const results = useQueries({
    queries: phones.map((phone) => {
      const params = { q: phone, user_id: userId, size: 100 }
      return {
        queryKey: getListConversationsApiV1ConversationsGetQueryKey(params),
        queryFn: ({ signal }: { signal: AbortSignal }) =>
          listConversationsApiV1ConversationsGet(params, signal),
      }
    }),
  })

  let total = 0
  results.forEach((result, index) => {
    const phone = phones[index]
    for (const item of result.data?.data.items ?? []) {
      if (item.to_number === phone) total += item.unread_count ?? 0
    }
  })
  return total
}
